import { Injectable } from '@angular/core';
import { map, concatMap } from 'rxjs';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as widgetConfigActions from '@dashboard-widget/actions/dashboard-widget-config.actions';
import { DashboardWidgetConfigService } from '@dashboard-widget/services/dashboard-widget-config.service';

@Injectable()
export class DashboardWidgetConfigEffects {

  constructor(
    private readonly actions: Actions,
    private readonly configService: DashboardWidgetConfigService) {
  }

  load = createEffect(() => this.actions.pipe(
    ofType(widgetConfigActions.getDashboardWidgetConfiguration),
    concatMap(action => {
      return this.configService.getConfig(action.widgetId).pipe(
        map(data => widgetConfigActions.getDashboardWidgetConfigurationComplete({ widgetId: action.widgetId, config: data.DashboardWidgetConfiguration })
        ));
    })
  ));

  save = createEffect(() => this.actions.pipe(
    ofType(widgetConfigActions.saveDashboardWidgetConfiguration),
    concatMap(action => {
      return this.configService.saveConfig(action.widgetId, action.config).pipe(
        map(data => widgetConfigActions.getDashboardWidgetConfigurationComplete({
          widgetId: action.widgetId, config: data.DashboardWidgetConfiguration })
        ));
    })
  ));


}
